import axios from "@/plugins/axios";

const getAll = (params) => {
  return axios.get('/keyword', { params })
}

const create = (data) => {
  return axios.post(`/keyword`, data)
}

const update = (id, data) => {
  return axios.put(`/keyword/${id}`, data)
}

const deleteOne = (id) => {
  return axios.delete(`/keyword/${id}`)
}

const group = (data) => {
  return axios.post(`/keyword/group`, data)
}

const exportKeywords = (data) => {
  return axios.post(`/keyword/export`, data, { responseType: 'blob' })
}

export default {
  create,
  getAll,
  deleteOne,
  update,
  group,
  exportKeywords,
}